import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';


import {NvD3Module} from 'ng2-nvd3';

import {BsDatepickerModule, defineLocale} from 'ngx-bootstrap';
import {esLocale} from 'ngx-bootstrap/locale';
// d3 and nvd3 should be included somewhere
import 'd3';
import 'nvd3';
import {IndicadoresComponent} from "./indicadores/indicadores.component";
import {MaterialModule} from "../../../../material.module";
import {LoadingModule} from "../../../../autenticacion/loadingScreen/loading.module";
import {IndicadoresGestionComponent} from "./gestion/gestion.component";

import {NgxChartsModule} from '@swimlane/ngx-charts';
import {NgStringPipesModule} from "../../../../../pipes/string";
import {HelperFormGestionComponent} from "./gestion/helper/helperFormGestion.component";

defineLocale('es', esLocale);

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NvD3Module,
        NgxChartsModule,
        NgStringPipesModule,
        MaterialModule,
        BsDatepickerModule.forRoot(),
        LoadingModule
    ],
    declarations: [IndicadoresComponent, IndicadoresGestionComponent, HelperFormGestionComponent]
})
export class DashboardModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/reporte/dashboard/dashboard.module.ts